import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  monthlyData: [], 
  loading: false,
  error: false,
  errorMessage: "",
};

const RevenueAndExpensesSlice = createSlice({
  name: "revenueAndExpenses",
  initialState,
  reducers: {
    setRevenueAndExpenses(state, action) {
      state.monthlyData = action.payload;
      state.loading = false;
      state.error = false;
    },
    loadingRevenueAndExpenses(state, action) {
      state.loading = action.payload;
    },
    revenueAndExpensesError(state, action) {
      state.error = true;
      state.errorMessage = action.payload;
      state.loading = false;
    },
    clearRevenueAndExpensesError(state) {
      state.error = false;
      state.errorMessage = "";
    },
  },
});

export const {
  setRevenueAndExpenses,
  loadingRevenueAndExpenses,
  revenueAndExpensesError,
  clearRevenueAndExpensesError,
} = RevenueAndExpensesSlice.actions;

export default RevenueAndExpensesSlice.reducer;
